export const brandToCaseMap = {
  seek: 'SEEK',
  jobsdb: 'Jobsdb',
  jobstreet: 'Jobstreet',
  jora: 'Jora',
};
